export default __webpack_public_path__ + "static/media/portfolio.f5fa3144.png";